export enum Mode {
  CcInput = 'cc-input',
  CcSwiper = 'cc-swiper',
  AchInput = 'ach-input',
  Klarna = 'klarna-input',
  Undefined = '',
}
